import { atom } from "recoil";

const collaboratorsAtom = atom({
  key: 'collaborators',
  default: {
    payload: [],
    loading: false,
    total: 0
  }
});

const collaboratorTestsAtom = atom({
  key: 'collaboratorTests',
  default: {
    payload: [],
    loading: false
  }
});

const crudCollaboratorsAtom = atom({
  key: 'crudCollaborators',
  default: {
    status: 500,
    message: '',
    loading: false
  }
});

const invitationAtom = atom({
  key: 'invitation',
  default: {
    payload: null,
    loading: false,
    message: ''
  }
});

const iaSummaryAtom = atom({
  key: 'iaSummary',
  default: {
    payload: null,
    loading: false,
    message: ''
  }
});

const bulkLoadAtom = atom({
  key: 'bulkLoad',
  default: {
    status: 500,
    loading: false,
    message: ''
  }
});

const informAtom = atom({
  key: 'inform',
  default: {
    status: 500,
    loading: false,
    message: ''
  }
});

const templateAtom = atom({
  key:'planilla',
  default:{
    status:500,
    loading: false,
    message:''
  }
})

export { crudCollaboratorsAtom, collaboratorsAtom, collaboratorTestsAtom, invitationAtom, iaSummaryAtom, bulkLoadAtom, informAtom, templateAtom};